import React from 'react';

import { addOrRemoveClass, changeLocation, classNames } from '@/shared/helpers';
import arrowDownIcon from '@/static/images/arrowdown.svg';
import { IStaticLocale } from '@/interfaces/staticlocale';
import { IFinalProductProps } from '@/interfaces/products';

interface Props {
  lang: string;
  pathLang: string;
  locale: IStaticLocale;
  products: IFinalProductProps[];
  shouldApplyContrast: boolean;
}

const ProductList = (props: Props) => {
  const { lang, pathLang, locale, products, shouldApplyContrast } = props;

  const prefixPath = pathLang === '' ? pathLang : `/${lang}`;

  return (
    <>
      <div
        className="anim-drop-down-item nav-item-content"
        role="button"
        onClick={() =>
          addOrRemoveClass('active', '#responsive-navbar-products')
        }
      >
        <p>{locale.header.products}</p>
        <img
          src={arrowDownIcon}
          alt={locale.header.arrow_down_icon}
          className={classNames(shouldApplyContrast && 'image-with-contrast')}
        />
      </div>

      <ul
        id="responsive-navbar-products"
        className="nav-item-product-list-subcontent"
      >
        {products.map(({ id, name, currentPath }) => (
          <li key={id} className="anim-drop-down-item">
            <a onClick={() => changeLocation(`${prefixPath}${currentPath}`)}>
              {name}
            </a>
          </li>
        ))}
      </ul>
    </>
  );
};

export default ProductList;
